import httpClient from './httpClient';
import type { UserProfile, UpdateProfileRequest, ChangePasswordRequest } from '@/types/settings';

export async function getProfile(): Promise<UserProfile> {
  const mdResponse = await httpClient.get<UserProfile>('/settings/profile');
  return mdResponse.data;
}

/** Сервер відповідає 204 без тіла */
export async function updateProfile(mdData: UpdateProfileRequest): Promise<void> {
  await httpClient.put('/settings/profile', mdData);
}

export async function changePassword(mdData: ChangePasswordRequest): Promise<void> {
  await httpClient.post('/settings/change-password', mdData);
}
